<mat-table [dataSource]="dataSource">

  <ng-container matColumnDef="pageId">
    <mat-header-cell *matHeaderCellDef> Page</mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{element.pageId}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="question">
    <mat-header-cell *matHeaderCellDef> Question</mat-header-cell>
    <mat-cell *matCellDef="let element">
      <a (click)="$event.stopPropagation(); onView(element)">
        @if (element.alertType !== 'biographic') {
          <div>
            {{element.question}}
          </div>
        }
      </a>

    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="alertType">
    <mat-header-cell *matHeaderCellDef> Alert Type</mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{element | alertType}}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="firstName">
    <mat-header-cell *matHeaderCellDef> First Name</mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{element.firstName}}
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

  <mat-row *matRowDef="let row; columns: displayedColumns;"
    ecaThrottleClick
    (throttleClick)="onView(row)"
           [ngClass]="{
             inactive: row !== active,
             active: row === active
           }">
  </mat-row>

</mat-table>


